import React from 'react'
import {inputMessage} from './input-message'

const subcategoryInputMessage = (subcategory, options, category, division, packs) => {
  return inputMessage(subcategory, options, category, division, packs)
}

export {subcategoryInputMessage}
